import React from "react";
import styled from "styled-components";
import TAPICall from "./src/Common/APICall.js";
import BMBreachList from './src/Components/BM/BMBreachList.js';
import BreachList from './src/Components/Team/BreachList';
import BreachStore from "./src/Common/Store";
import Store from './../../../Common/Store';

const FolderContainer = styled.div`
    display: block;
    box-sizing: border-box;
    height: auto;
    width: 75%;
    position: absolute;
    margin: 8px;
    top: 8px;
    z-index: 1001;
    background-color: #f7f7f7;
    border-radius: 5px;
    border-color: #495E75;
    border-width: 3px;
    box-shadow: 0 0 20px #a7a6a6;
  `;


class BreachHOC extends React.Component {

    state={ready: false, role:''}

    componentDidMount(){
        this.setEnv('breach');
    }

    setEnv(module_name) {
        let api_url = `${Store.getStoreData('base_api_url')}/microservice/${module_name}/api/command`;
        BreachStore.updateStore('module_name',module_name);
        BreachStore.updateStore('api_url',api_url);
        BreachStore.updateStore('is_admin',false);
        BreachStore.updateStore('is_debug',false);

        let postData = { command: "taskindex" };
        let api = new TAPICall();
        api.command(postData, this.processtaskIndex);
    }

    processtaskIndex = (result) => {
        BreachStore.updateStore('module_config', result.result['module_config']);
        BreachStore.updateStore('contact_id', result.result['contact_id']);
        BreachStore.updateStore('curCompanyID', result.result['curCompanyID']);

        //set company start
        let gc_comp = Store.getStoreData('gc_companie');
        let my_mgrp_companies = [];
        for(let k=0;k<gc_comp.length;k++){
            console.log("gc_comp===>", gc_comp[k].id, "gc_companies=>", result.result['curCompanyID'])
            if(gc_comp[k].id !== result.result['curCompanyID']){
                let my_mgrp_comObject = {};
                my_mgrp_comObject.address1 = gc_comp[k].address1
                my_mgrp_comObject.address2 = gc_comp[k].address2
                my_mgrp_comObject.company_name = gc_comp[k].company_name
                my_mgrp_comObject.created_at = gc_comp[k].created_at
                my_mgrp_comObject.id = gc_comp[k].id
                my_mgrp_comObject.is_deleted = gc_comp[k].is_deleted
                my_mgrp_comObject.parent_id = gc_comp[k].parent_id
                my_mgrp_comObject.phone = gc_comp[k].phone
                my_mgrp_comObject.tags_config = gc_comp[k].tags_config !== null ? JSON.stringify(gc_comp[k].tags_config) : null;
                my_mgrp_comObject.updated_at = gc_comp[k].updated_at
                my_mgrp_companies.push(my_mgrp_comObject)
            }
        }
        let gc_companies = my_mgrp_companies;
        console.log("gc_comp===>", gc_comp, "gc_companies=>", gc_companies)
        BreachStore.updateStore('gc_company', gc_comp);
        BreachStore.updateStore('gc_companies', gc_companies);
        //set company end


        let has_gc = gc_comp.length > 1 ? true : false;
        BreachStore.updateStore('has_gc',has_gc);

        let gc_assoc = {}
        let gc_filters = {};
        for(let gc of gc_comp) {
            let gc_id = gc.id.toString();
            gc_assoc[gc_id] = gc.company_name;
            if(gc.is_gc) {
              gc_filters[gc.id.toString()] = 1;
            }
        }
        console.log("gc_filters==>", gc_filters)
        BreachStore.updateStore('gc_filters', gc_filters);
        BreachStore.updateStore('gc_assoc', gc_assoc);

        let r = {};
        r['result'] = {};
        let cts = localStorage.getItem("contactlist")!==null ? JSON.parse(localStorage.getItem("contactlist")) : r;
        console.log('cts==>', cts)
        let user_roles = {};
        let contacts_all = {};
        let contractsemail_all = {};
        let listcontacts_all = [];
        if('contactlist' in cts.result && 'user_roles' in cts.result) {
          user_roles = cts.result.user_roles['breach'];
          for(let k in cts.result.contactlist){
            if(user_roles[k.toString()] !== undefined){
              contractsemail_all[k.toString()] = cts.result.contactlist[k.toString()].EmailAddress;
              let listConObject = {};
              listConObject.ID = cts.result.contactlist[k.toString()].ID;
              listConObject.ContactName = cts.result.contactlist[k.toString()].ContactName;
              listConObject.LoginID = cts.result.contactlist[k.toString()].EmailAddress;
              listcontacts_all.push(listConObject);
              if (cts.result.user_roles['breach'][k.toString()] !== 'no_access' ) {
                  contacts_all[k.toString()] = cts.result.contactlist[k.toString()].ContactName;
              }
            }
          }
          console.log("user_roles", user_roles);
          BreachStore.updateStore('userroles', user_roles);
          BreachStore.updateStore('contacts', contacts_all);
          BreachStore.updateStore('contactsemail', contractsemail_all);
          BreachStore.updateStore('reviewee_list', listcontacts_all);
        }

        let userroles = BreachStore.getStoreData("userroles");
        let contact = Store.getStoreData("contact");
        let role = userroles[contact.ID.toString()];
        BreachStore.updateStore('role', role);
        BreachStore.updateStore('isreferenceUrl', true)
        this.setState({ready: true, role})
    }

    closeUserDialog = () => {
        this.setState({show_modal: false})
        this.props.closeUserDialog()
    }

    render() {
        if(!this.state.ready)return(<div></div>)
        return(
            <FolderContainer>
                {
                    (() => {
                        switch(this.state.role) {
                        case 'manager' :
                        case 'bm' : return <BMBreachList taskId={this.props.task_id} closeUserDialog={this.closeUserDialog}/>; break;
                        case 'team' : return <BreachList taskId={this.props.task_id} closeUserDialog={this.closeUserDialog}/>; break;
                        default: return <div>Sorry, you do not have permission to view this page. </div>;
                        }
                    })()
                }
            </FolderContainer>
        );
    }
}

export default BreachHOC;
